import SalesService from './SalesServices.view';

export default SalesService;